import { BOWTIE_PINK, GREEN_DAY } from '@bowtie-ins/bowkit/palette';
import { SumAssuredRange } from '@bowtie-web/common';
import { keyBy } from 'lodash';
import { FormattedMessage } from 'react-intl';
import { DemographicInput, ProductSpec } from '../types';

export const DEFAULT_RANGE: SumAssuredRange = {
  product: '',
  min_issue_age: 0,
  max_issue_age: 65,
  min_sum_assured: 200000,
  max_sum_assured: 1000000,
  create_date: '',
};

export const EXTRA_PRODUCT_SPECS: ProductSpec[] = [
  {
    headlineColor: '#0251ff',
    code: 'vhis-standard',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.standard" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'vhis-flexi-regular',
    order: 1,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-regular" />
    ),
  },
  {
    headlineColor: '#37b729',
    code: 'vhis-flexi-plus',
    order: 2,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-plus" />
    ),
  },
  {
    headlineColor: GREEN_DAY,
    code: 'vhis-flexi-premium-ward-1',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-ward" />
    ),
  },
  {
    headlineColor: GREEN_DAY,
    code: 'vhis-flexi-premium-ward-2',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-ward" />
    ),
  },
  {
    headlineColor: GREEN_DAY,
    code: 'vhis-flexi-premium-ward-3',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-ward" />
    ),
  },
  {
    headlineColor: GREEN_DAY,
    code: 'vhis-flexi-premium-ward-4',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-ward" />
    ),
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-1',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-semi-private" />
    ),
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-2',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-semi-private" />
    ),
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-3',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-semi-private" />
    ),
  },
  {
    headlineColor: '#F05F00',
    code: 'vhis-flexi-premium-semi-private-4',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-semi-private" />
    ),
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-1',
    order: 1,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-private" />
    ),
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-2',
    order: 1,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-private" />
    ),
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-3',
    order: 1,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-private" />
    ),
  },
  {
    headlineColor: '#8800FF',
    code: 'vhis-flexi-premium-private-4',
    order: 1,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.vhis.flexi-premium-private" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'touch-wood-protector',
    order: 0,
    demographicInputs: [DemographicInput.Gender, DemographicInput.Age],
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.accidental-medical.touch-wood-protector" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'cancer-fighter-100',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.medical.cancer-fighter-100" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'cancer-fighter-200',
    order: 1,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.medical.cancer-fighter-200" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'cancer-fighter-300',
    order: 2,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.medical.cancer-fighter-300" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'term-life',
    order: 0,
    sumAssuredInput: true,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.term-life" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'term-level-life-5',
    order: 1,
    sumAssuredInput: true,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.term-level-life-5" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'term-level-life-10',
    order: 2,
    sumAssuredInput: true,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.term-level-life-10" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'term-level-life-20',
    order: 3,
    sumAssuredInput: true,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.term-level-life-20" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'last-wish-rider',
    order: 0,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.last-wish-rider" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'last-wish-rider-5',
    order: 1,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.last-wish-rider-5" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'last-wish-rider-10',
    order: 2,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.last-wish-rider-10" />
    ),
  },
  {
    headlineColor: '#ff0202',
    code: 'last-wish-rider-20',
    order: 3,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.life.last-wish-rider-20" />
    ),
  },
  {
    headlineColor: '#0251ff',
    code: 'term-ci',
    order: 0,
    sumAssuredInput: true,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.critical-illness.term-ci" />
    ),
  },
  {
    headlineColor: '#f05f00',
    code: 'term-ci-plus',
    order: 1,
    sumAssuredInput: true,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.critical-illness.term-ci-plus" />
    ),
  },
  {
    headlineColor: '#37b729',
    code: 'term-ci-max',
    order: 2,
    sumAssuredInput: true,
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.critical-illness.term-ci-max" />
    ),
  },
  {
    headlineColor: BOWTIE_PINK, // placeholder
    code: 'bb-ci',
    order: 3,
    demographicInputs: [DemographicInput.Age],
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.critical-illness.bb-ci" />
    ),
    defaultFormValues: {
      sumAssured: 500000, // TODO: use the sum assured range max sum assured instead of hardcoding
      gender: 'female',
      age: 20,
      smoker: 'non-smoker',
    },
  },
  {
    headlineColor: BOWTIE_PINK, // placeholder
    code: 'juvenile-ci',
    order: 4,
    demographicInputs: [DemographicInput.Age, DemographicInput.Gender],
    sumAssured: true,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.critical-illness.juvenile-ci" />
    ),
    defaultFormValues: {
      sumAssured: 500000,
      smoker: 'non-smoker',
    },
  },
  {
    headlineColor: BOWTIE_PINK,
    code: 'parent-medical-standard',
    order: 0,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.parent-medical.parent-medical-standard" />
    ),
  },
  {
    headlineColor: BOWTIE_PINK,
    code: 'parent-medical-advance',
    order: 1,
    sumAssured: false,
    premiumScheduleLabel: (
      <FormattedMessage id="term-and-conditions.parent-medical.parent-medical-advance" />
    ),
  },
];

export const EXTRA_PRODUCT_SPECS_BY_CODE: Record<string, ProductSpec> = keyBy(
  EXTRA_PRODUCT_SPECS,
  'code',
);
